<div class="k-list-container">
	<div class="cp-list-scroller k-list-scroller">
		<ul class="k-list k-reset">
			<li class="k-list-item"
				[ngClass]="{'k-selected': i == selectedIndex}"
				*ngFor="let item of items; trackBy:trackByIndex; let i = index;"
				(click)="itemClickHandler($event, i, item)"
				title="{{(displayField && displayField !== '') ? item[displayField] : item}}">
				{{(displayField && displayField !== '') ? item[displayField] : item}}
			</li>
		</ul>
	</div>
</div>
